export default "__VITE_ASSET__BdEw8UZ8__"